module.exports = __webpack_public_path__ + "labioplastika_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_7_before.jpg
// module id = 1080
// module chunks = 0